module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-2@3x__d929b9442026441962fb8c71f8f2a218.png";